/**
 * Repair Point brand mark — cartoon robot mascot with circuit shield.
 * The whole image gently waves/tilts on hover and continuously on the
 * homepage header (a friendly "hi!" motion).
 */
export default function Logo({ className = "h-10 w-10", animate = true }) {
  return (
    <span
      aria-hidden
      className={`relative inline-block shrink-0 ${className} ${animate ? "rp-mascot-wave" : ""}`}
    >
      <img
        src="/logo-mascot.png"
        alt="Repair Point robot mascot"
        className="h-full w-full object-contain select-none"
        draggable="false"
      />
    </span>
  );
}
